/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { TimeseriesLocalRain } from "./TimeseriesLocalRain";
import {
  TimeseriesLocalRainFromJSON,
  TimeseriesLocalRainFromJSONTyped,
  TimeseriesLocalRainToJSON,
  TimeseriesLocalRainToJSONTyped,
} from "./TimeseriesLocalRain";

/**
 *
 * @export
 * @interface PaginatedTimeseriesLocalRainList
 */
export interface PaginatedTimeseriesLocalRainList {
  /**
   *
   */
  count: number;
  /**
   *
   */
  next?: string | null;
  /**
   *
   */
  previous?: string | null;
  /**
   *
   */
  results: Array<TimeseriesLocalRain>;
}

/**
 * Check if a given object implements the PaginatedTimeseriesLocalRainList interface.
 */
export function instanceOfPaginatedTimeseriesLocalRainList(
  value: object
): value is PaginatedTimeseriesLocalRainList {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function PaginatedTimeseriesLocalRainListFromJSON(
  json: any
): PaginatedTimeseriesLocalRainList {
  return PaginatedTimeseriesLocalRainListFromJSONTyped(json, false);
}

export function PaginatedTimeseriesLocalRainListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PaginatedTimeseriesLocalRainList {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(TimeseriesLocalRainFromJSON),
  };
}

export function PaginatedTimeseriesLocalRainListToJSON(
  json: any
): PaginatedTimeseriesLocalRainList {
  return PaginatedTimeseriesLocalRainListToJSONTyped(json, false);
}

export function PaginatedTimeseriesLocalRainListToJSONTyped(
  value?: PaginatedTimeseriesLocalRainList | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(TimeseriesLocalRainToJSON),
  };
}
